<template>
    <div>
        <content-view >
        <!-- 渠道管理-访问详情 -->
        <div slot="header">
            <a-form :form="filterForm" layout="inline" class="store-one-form">
                <a-form-item label="日期">
                    <a-date-picker format="YYYY-MM-DD" v-decorator="['date', {initialValue: defaultValue}]"/>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button type="primary" @click="search">筛选</a-button>
                    <a-button @click="handleReset()">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <a-card>
            <template slot="title"><a-icon type="info-circle" style="padding-right: 8px;color: #FFBF00;margin-top: 2px;"/>当日点击量：{{pagination.total}} 次</template>
            <template v-if="getBtnByAuth('exportChannel')" slot="extra">
                <a-button type="primary" @click="exportExcel" :loading="loading">导出excel</a-button>
                <a-button @click="openExportModal">导出记录</a-button>
            </template>
            <a-table
            bordered
            :dataSource="dataSource"
            :columns="columns"
            :pagination="pagination"
            :rowKey="record => record.id"
            @change="changePage"
            >
                <span slot="index" slot-scope="a,b,index">{{index+1}}</span>
                <span slot="phone" slot-scope="phone">{{phone ? phone : "-"}}</span>
                <span slot="ip" slot-scope="ip">{{ip ? ip : "-"}}</span>
                <span slot="isConsume" slot-scope="isConsume">{{isConsume ? '是' : '否'}}</span>
            </a-table>
            <report-export-modal ref="reportExportModal" :exportType="36"></report-export-modal>
        </a-card>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from 'moment'
    export default {
        name: 'channel',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '序号',
                    dataIndex: 'index',
                    scopedSlots: { customRender: "index" }
                },
                {
                    title: '用户IP',
                    dataIndex: 'ip',
                    scopedSlots: { customRender: "ip" }
                },
                {
                    title: '用户手机号',
                    dataIndex: 'phone',
                    scopedSlots: { customRender: "phone" }
                },
                {
                    title: '手机型号',
                    dataIndex: 'phoneModel'
                },
                {
                    title: '点击时间',
                    dataIndex: 'occurTime'
                },
                {
                    title: "是否消费",
                    dataIndex: "isConsume",
                    scopedSlots: { customRender: "isConsume" }
                },
            ];
            return {
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                newStorageVisible: false, //添加仓库
                filterForm: this.$form.createForm(this), //筛选表单
                form: this.$form.createForm(this), //添加和编辑表单
                id: '',
                defaultValue: moment(),
                loading: false
            };
        },
        beforeCreate() {},
        watch: {},
        computed: {},
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            //获取列表
            getList() {
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    values.date = moment(values.date).format('YYYY-MM-DD');
                    this.$api.totalPlatform.queryInfo({
                        body: {
                            ...values,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            channelMark: this.$route.query.channelMark
                        }
                    }).then(res => {
                        this.dataSource = res.list;
                        this.pagination.total = res.total;
                    });
                })
            },
            // 导出excel
            exportExcel() {
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    values.date = moment(values.date).format('YYYY-MM-DD');
                    this.loading = true
                    this.$api.totalPlatform.channelExport({
                        body: Object.assign(values,
                        {
                            channelMark: this.$route.query.channelMark,
                            pageNum: 1,
                            pageSize: this.pagination.total,
                        })
                    }).then(res => {
                        this.openExportModal();
                        this.loading = false;

                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            },
        },
        created() {},
        mounted() {
            this.getList();
        },
        watch: {}
    };
</script>
<style lang="scss">
</style>